/**
 * @desc 获取菜单
 */
const URL = "/rantion-activiti";
import http, { updateResponse } from "@/http";
export type Response = defs.activiti.ResponseDto<string>;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/activiti/editor/stencilset`, {
      method: "GET",

      ...options,
    }),
  );
}
